module.exports = __webpack_public_path__ + "img/tbzy-white.69284362.png";